import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import withPrivileges from '../../hocs/withPrivileges';
import Privileges from '../../utils/Privileges';
import { auctioneerDataTemplatePropertiesType } from '../../types';
import CreateButton from '../buttons/CreateButton';
import AuctioneerDataTemplateCreateTab from './AuctioneerDataTemplateCreateTab';

CreateAuctioneerDataTemplateRow.propTypes = {
    auctioneerDataTemplateProps: auctioneerDataTemplatePropertiesType.isRequired,
};

function CreateAuctioneerDataTemplateRow(props) {
    const {
        auctioneerDataTemplateProps,
    } = props;
    const { t } = useTranslation();
    const [isCreateVisible, setCreateVisible] = useState(false);
    const actionHandler = () => setCreateVisible(!isCreateVisible);
    return (
        <div className="create-auctioneer-data-template-row">
            <CreateButton
                onAction={actionHandler}
                isCreateVisible={isCreateVisible}
            >
                <FontAwesomeIcon icon="plus" />&nbsp;{t('auctioneer-data-templates.create-auctioneer-data-template')}
            </CreateButton>
            {isCreateVisible && (
                <AuctioneerDataTemplateCreateTab
                    hideHandler={() => setCreateVisible(false)}
                    auctioneerDataTemplateProps={auctioneerDataTemplateProps}
                />
            )}
        </div>
    );
}

export default withPrivileges([Privileges.AUCTIONEER_DATA_TEMPLATE_EDIT])(CreateAuctioneerDataTemplateRow);
